module.exports = __webpack_public_path__ + "img/bj-golden-blackberry.d7ba9543.gif";